import { useState } from "react";
import CheckComponent from "../../../../../shared/components/checkComponent";
import useAppStateStore from "../../../../../shared/store/AppStateStore";
import SupportStep from "../../../enums/SupportStep";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import { scrollToTop } from "../../../../../shared/utils/scrollUtils";
import PortalBackButton from "../../../components/PortalBackButton";
import useSupportStore from "../../../store/supportStore";
import { updateSupportType } from "../../../utils/supportNavUtils";

const stepOptions = [
  { id: SupportStep.SP_ADDRESS, title: "Address" },
  { id: SupportStep.SP_VEHICLE, title: "Vehicle" },
  { id: SupportStep.SP_LICENSE, title: "Licensing Authority" },
  { id: SupportStep.SP_REGISTRATION, title: "Registration" },
  { id: SupportStep.SP_USE, title: "Use" },
  { id: SupportStep.SP_CANCELLATION, title: "Cancellation" },
  { id: SupportStep.SP_OTHER, title: "Other" },
];

const CANCELLATION_ID = SupportStep.SP_CANCELLATION;

const Sp1 = () => {
  const [error, setError] = useState("");
  let STATE = useAppStateStore();
  const store = useSupportStore.getState();

  const selectedSteps = Array.isArray(STATE.selectedOptions)
    ? STATE.selectedOptions
    : [];

  const isCancellationSelected = selectedSteps.some(
    (step) => step.id === CANCELLATION_ID
  );
  const isInvalidCombo = isCancellationSelected && selectedSteps.length > 1;

  const handleCheckboxChange = (id, title) => {
    const prev = Array.isArray(STATE.selectedOptions)
      ? STATE.selectedOptions
      : [];
    const exists = prev.find((step) => step.id === id);
    let newSteps;
    if (exists) {
      newSteps = prev.filter((step) => step.id !== id);
    } else {
      newSteps = [...prev, { id, title }];
    }
    // Prevent selecting anything else with cancellation
    if (
      (id === CANCELLATION_ID && !exists && prev.length > 0) ||
      (id !== CANCELLATION_ID &&
        prev.some((step) => step.id === CANCELLATION_ID))
    ) {
      setError("You cannot select anything else with cancellation.");
      return;
    }
    setError("");
    STATE.setSelectedOptions(newSteps);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (selectedSteps.length < 1) {
      setError("Please select at least one option before proceeding.");
      return;
    }
    if (isInvalidCombo) {
      setError("You cannot select anything else with cancellation.");
      return;
    }
    setError("");
    STATE.setSpCurrentStep(selectedSteps[0].id);
    updateSupportType();
    scrollToTop();
  };

  return (
    <>
      <QuoteFormWrapper>
        <form onSubmit={onSubmit}>
          <h1 className="margin-bottom-15">Make a change to your policy</h1>
          <p className="gray-text margin-bottom-30">
            Complete the below form to get a quote to change or cancel your
            policy. Once you have entered the information you will receive a
            quote via email and SMS.
          </p>
          <h3 className="margin-bottom-30">
            Which of the following do you want to change?
          </h3>
          <div className="optionsDiv">
            {stepOptions.map(({ id, title }) => (
              <CheckComponent
                key={id}
                title={title}
                id={id}
                checked={selectedSteps.some((step) => step.id === id)}
                onChange={() => handleCheckboxChange(id, title)}
              />
            ))}
          </div>
          <p className="gray-text">
            If you want to make more than one change, please select all the
            applicable options above and click on next.
          </p>
          {error && <p className="errorField">{error}</p>}
          <button
            type="submit"
            className={
              selectedSteps.length < 1 || isInvalidCombo
                ? "disabledBtn getStartedButton"
                : "getStartedButton"
            }
          >
            Get Started
          </button>
        </form>
      </QuoteFormWrapper>
      <PortalBackButton />
    </>
  );
};

export default Sp1;
